import { Loader } from "@googlemaps/js-api-loader";

export class GoogleMapsLoader {
    private static _loader: Loader | null = null;

    static getLoader(apiKey: string): Loader {
        this._loader ??= new Loader({
            apiKey,
            version: "quarterly" // same intent as your script tag
            // do NOT pass libraries here if you plan to use importLibrary()
        });
        return this._loader;
    }
}